import { NgModule, ErrorHandler, SkipSelf, Optional } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { NgxsModule } from '@ngxs/store';
import { FmErrorHandlerService } from './fm-error-handler.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NotFoundComponent } from './not-found/not-found.component';
import { environment } from '../../environments/environment';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorInterceptor } from './error-interceptor.service';
import { LoadingState } from './loading.state';
import { AuthInterceptor } from './auth.interceptor';
import { LayoutState } from './layout.state';
import { FirebaseState } from './firebase.state';
import { LangTagPipe } from '../features/shared-components/lang-tag.pipe';

@NgModule({
  declarations: [NotFoundComponent],
  imports: [
		LangTagPipe,
    BrowserModule,
    BrowserAnimationsModule,
    NgxsModule.forRoot([LoadingState, FirebaseState, LayoutState], {
      developmentMode: !environment.production,
      selectorOptions: {
        suppressErrors: false,
        injectContainerState: false,
      },
    }),
    environment.plugins,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: FmErrorHandlerService,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it in the AppModule only');
    }
  }
}
